import moment from 'moment';
import i18n from 'i18n';
import { get } from 'lodash';
import getLocalized from 'utils/get-localized';
import PLAYER_TYPES from 'constants/player-types';

export const getProgramNavHint = (program) => {
  if (!program) return '';
  const startTime = moment(program.startTime).format('HH:mm');
  const title = getLocalized(program.titles, program.title);
  return `${startTime}  ${title}`;
};

export const getEpisodeNavHint = (episode) => {
  return episode ? getLocalized(episode.titles, episode.title).title : '';
};

export const getNavigationButtonConfig = (params) => {
  const { playerType, buttonType, navigation, isLive, isResetToStartAvailable } = params;
  const resetI18nKey = 'player.resetToStart';
  let disabled = true;
  let isHidden = false;
  let hint = '';

  if (playerType === PLAYER_TYPES.SERIES) {
    const prevItem = get(navigation, [`${buttonType}Episode`]);
    disabled = !prevItem && !isResetToStartAvailable;
    hint = isResetToStartAvailable ? i18n.t(resetI18nKey) : getEpisodeNavHint(prevItem);
  } else if (
    [PLAYER_TYPES.CHANNEL, PLAYER_TYPES.CATCHUP, PLAYER_TYPES.VOD_CHANNEL].includes(playerType)
  ) {
    const prevItem = get(navigation, [`${buttonType}Program`], {});
    disabled = !prevItem.startTime && !isResetToStartAvailable;
    isHidden = !prevItem.startTime;
    hint = isResetToStartAvailable ? i18n.t(resetI18nKey) : getProgramNavHint(prevItem);
  } else if (playerType === PLAYER_TYPES.TIMESHIFT) {
    if (buttonType === 'next') {
      disabled = isLive;
      hint = i18n.t('player.buttons.backToAir');
    } else {
      const prevItem = get(navigation, [`${buttonType}Program`], {});
      disabled = !prevItem.startTime && !isResetToStartAvailable;
      isHidden = !prevItem.startTime;
      hint = isResetToStartAvailable ? i18n.t(resetI18nKey) : getProgramNavHint(prevItem);
    }
  } else {
    disabled = !isResetToStartAvailable;
    hint = isResetToStartAvailable ? i18n.t(resetI18nKey) : '';
  }

  return { disabled, hint, isHidden };
};
